<template>
    <button ref="btn" class="btn btn-copy btn-link btn-xs" :data-clipboard-target="target" v-bind="$attrs">
        <i class="fas fa-file mr-2 text-info" ></i>
        <span class="text-info" :class="{ 'sr-only': hideText }" key="lang_copy_to_clipboard" >Copy to Clipboard</span>
    </button>
</template>

<script>
import Clipboard from 'clipboard/dist/clipboard.min.js';

export default {
    props: {
        target: {
            type: String,
            required: true
        },
        hideText: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            clipboard: null
        };
    },
    mounted () {
        this.clipboard = new Clipboard(this.$refs.btn);
    },
    beforeDestroy () {
        this.clipboard.destroy();
    }
};
</script>
